import { Flow_0_0_2, getFullItemTwo } from '@flexus/core';
import { map, tap } from 'rxjs/operators';
import { environment } from '../../../../../../environments/environment';
import { CONTEXT_DATA_CALLS } from '../../reusable/DATA_CALLS';
import { CollapseActionPanel, setActionPanelItems } from '../../../../../app-shell-features';
import { of } from 'rxjs';

export const SIL_UPLOAD_DOCUMENTS: Flow_0_0_2 = {
	id: 'UploadDocuments',
	itemType: 'flow',
	fetchLevel1And2: true,
	name: 'Upload Documents',
	header: {
		title: (store, bf) => {
			return store.select(getFullItemTwo).pipe(
				map(itemTwo => {
					if (itemTwo) {
						if (itemTwo?.claim?.applicant) {
							return `Upload Documents : ${itemTwo?.claim?.loan_information?.mavenclaimnumber} - ${itemTwo?.claim?.applicant?.surname}`;
						} else {
							return 'Upload Documents';
						}
					}
				})
			);
		},
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	startNode: 'UploadDocuments',
	instructions: {
		editRoles: {
			0: ''
		},
		viewRoles: {
			0: ''
		}
	},
	onStateInit: inst => {
		// inst.store.dispatch(new CollapseActionPanel());
		// const paramFunc = (inst, mapper) => {
		//   return {
		//     id: 'claim-excess',
		//     icon: 'excess-details',
		//     command: inst.loadComponent.bind(inst, mapper['FLXExcessDetailsOnJobComponent'])
		//   };
		// };
		// inst.navService.portalActions.next({ call: 'onClick', paramFunc });
	},
	onStateDestroy: inst => {
		// inst.store.dispatch(new CollapseActionPanel());
	},
	actionPanel: instance => setActionPanelItems(instance, ['claim-excess', 'sp-details']),
	serverCalls: {
		...CONTEXT_DATA_CALLS
	},
	nodes: {
		UploadDocuments: {
			component: 'FLXUploadDocumentsComponent',
			inputs: {
				location: 'screen'
			},
			name: 'Upload Documents',
			serverCalls: {},
			navs: [
				{
					text: 'Upload Document',
					optIntoValidation: true,
					color: 'primary',
					linkType: 'submit',
					serverCalls: {
						uploadDoc: {
							errorMessage: 'File could not be uploaded',
							timeoutMilliseconds: 2000,
							directCall: (http, store, sq, bf, cnt, modal) => {
								const fileQueue = bf.bigForm.get('fileQueue')?.value as Array<any>;
								const body: any = {
									data: fileQueue[0]?.file.base64,
									job_id: bf.bigForm.get('itemTwo')?.value?.id,
									purpose: bf.bigForm.get('purpose')?.value,
									invoice_number: bf.bigForm.get('invoice_number') ? bf.bigForm.get('invoice_number')?.value : undefined,
									filename: `${bf.bigForm.get('purpose')?.value}-${bf.bigForm.get('itemTwo')?.value?.id}`
								};
								if (bf.bigForm.get('purpose')?.value === 'Photo') {
									body.filename += `.${fileQueue[0]?.file.type.substring(fileQueue[0]?.file.type.indexOf('/') + 1)}`;
									body.filename = body.filename?.replace('jpeg', 'jpg');
									body.thumbnail = fileQueue[0]?.file.base64;
								} else {
									body.filename += '.pdf';
								}
								return http
									.post(`${environment.api_url}v1/file_action/upload_file/`, body, {
										observe: 'events',
										reportProgress: true
									})
									.pipe(
										tap(value => {
											if (value.status === 200) {
												modal.openModalDirectly(instance => {
													instance.type = 'success';
													instance.message = 'File has been uploaded successfully';
													instance.navButtons = [
														{
															text: 'Back',
															linkType: 'close',
															color: 'success'
														}
													];
												});
											}
										})
									);
							},
							followUpSuccessCalls: {
								files: {
									serviceVariable: 'silService',
									functionName: 'getAllJobFiles',
									responseSlice: 'payload',
									errorMessage: 'Could not get files from server!'
								}
							},
							followUpFailCalls: {
								displaySucces: {
									errorMessage: 'Could not diplay success',
									directCall: (http, store, sq, bf, con, modal) => {
										modal.openModalDirectly(inst => {
											inst.type = 'warning';
											inst.heading = 'Could not upload file.';
											inst.navButtons = [
												{
													text: 'Continue',
													color: 'secondary',
													linkType: 'close'
												}
											];
										});
										return of(false);
									}
								}
							}
						}
					}
				}
			]
		}
	}
};
